import { render, staticRenderFns } from "./DefaultTable.vue?vue&type=template&id=78266c72&scoped=true"
import script from "./DefaultTable.vue?vue&type=script&lang=js"
export * from "./DefaultTable.vue?vue&type=script&lang=js"
import style0 from "./DefaultTable.vue?vue&type=style&index=0&id=78266c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78266c72",
  null
  
)

export default component.exports